import { useState } from 'react';

import { IS32LocalBusUnit } from 'features/systems/IS32/domain/models/IS32-localbus-unit';

export interface IS32OverflowMenuHook {
  onOverflowMenuClicked: (event: React.MouseEvent<HTMLElement>, row: IS32LocalBusUnit, poEntryIndex?: number) => void;
  closeOverflowMenu: () => void;
  isOverflowMenuOpen: boolean;
  anchorEl: HTMLElement | null;
  clickedRow: IS32LocalBusUnit | null;
  clickedPOEntryIndex: number | undefined;
}

const useIS32OverflowMenuHook = (): IS32OverflowMenuHook => {
  const [isOverflowMenuOpen, setIsOverflowMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [clickedRow, setClickedRow] = useState<IS32LocalBusUnit | null>(null);
  const [clickedPOEntryIndex, setClickedPOEntryIndex] = useState<number | undefined>();

  const onOverflowMenuClicked = (event: React.MouseEvent<HTMLElement>, row: IS32LocalBusUnit, index?: number) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setIsOverflowMenuOpen(true);
    setClickedRow(row);
    setClickedPOEntryIndex(index);
  };

  const closeOverflowMenu = () => {
    setIsOverflowMenuOpen(false);
    setClickedRow(null);
  };

  return {
    onOverflowMenuClicked,
    closeOverflowMenu,
    isOverflowMenuOpen,
    anchorEl,
    clickedRow,
    clickedPOEntryIndex,
  };
};

export default useIS32OverflowMenuHook;
